
import { Vue, Component } from "vue-property-decorator";

@Component
export default class InboxWindowEmpty extends Vue {
  isMobile: boolean = window.innerWidth <= 768;

  get message() {
    return this.isMobile
      ? "Loading a conversation"
      : "Please select a conversation";
  }
}
